import dayjs from 'dayjs';

export const formatDate = (date: string | null | undefined) => {
  if (date === '18000101' || date === '0001-01-01T00:00:00' || date === null || date === undefined || date === '') {
    return '';
  }
  return dayjs(date, 'YYYYMMDD').format('YYYY-MM-DD');
};

export const formatDateAndTime = (date: string | null | undefined) => {
  if (date === '18000101' || date === '0001-01-01T00:00:00' || date === null || date === undefined || date === '') {
    return '';
  }
  return dayjs(date).format('YYYY-MM-DD HH:mm');
};
